export const INITIAL = {
  sandboxArea: { W: 0, H: 0 },
}
